(function () {  
  if (!window.Shopify && !Shopify.designMode) {
    if (pathname.startsWith("/a/return-portal")) {
      window.location.assign('/apps/redo/returns-portal/login');
    }
  }
  const productJson = document.querySelector('[data-product-json]');
  if (!productJson) return;
  const product = JSON.parse(productJson.textContent);
  const variants = product.variants;
  //console.log(variants);
  //console.log(productJson, product, variants);
  const pathname = window.location.pathname;
  const searchParams = window.location.search;
  //console.log(pathname, searchParams);
  //console.log(window.Shopify);
  /*
  if (window.Shopify && !Shopify.designMode) {
    //console.log('here');
    if (pathname.includes("/products/") && !searchParams) {
      const preferredOptions = JSON.parse(localStorage.getItem("preferredOptions"));
      if (Array.isArray(preferredOptions)) {
        const variant = variants.find(v => v.options.toString() === preferredOptions.toString()) ||
          variants.find(v => v.options[1] === preferredOptions[1]) ||
          variants.find(v => v.options[0] === preferredOptions[0]);
        if (variant) {
          window.location.replace(`${window.location.pathname}?variant=${variant.id}`);
        }
      }
    }
  }
  */

  function updateBidirectionalAvailability(e) {
    //console.log('updateBidirectionalAvailability',e);
    if (e?.detail?.variant?.options) {
        localStorage.setItem("preferredOptions", JSON.stringify(e?.detail?.variant?.options))
    }
    
    const optionContainers = document.querySelectorAll('variant-picker');
    optionContainers.forEach(container => {
      //console.log(container);
      
      container
        .querySelectorAll('fieldset')
        .forEach(fieldset => {
          const label = fieldset.querySelector('.variant-picker__option-info span');
          const checked = fieldset.querySelector(':checked');
          if (checked) {
            label.style.removeProperty('color');
            label.textContent = checked.dataset.value;
          } else {
            label.style.color = '#FF6699';
          }
        });

      const selectedVariant = JSON.parse(container.querySelector('[data-variant]').textContent);
      const noRestock = JSON.parse(document.querySelector('[data-no-restock-json]').textContent);
      //console.log('selectedVariant',selectedVariant,'noRestock',noRestock);
      document.querySelectorAll('.klaviyo-bis-trigger').forEach(klaviyoBisButton => {
        klaviyoBisButton.classList.toggle('block', !selectedVariant?.available && !noRestock);
        klaviyoBisButton.classList.toggle('hidden', !selectedVariant || selectedVariant?.available || noRestock);
      });
      const selections = Array.from(container.querySelectorAll('fieldset'), fieldset => fieldset.querySelector('input:checked')?.dataset?.value ?? '');
      //console.log(selectedVariant, selections);

      container
        .querySelectorAll('input')
        .forEach(button => {
          const value = button.dataset.value;
          const isAvailable = variants.some(variant => {
            //console.log(variant);
            if (!variant.available) return false;

            return variant.options.every((opt, idx) => {
              const optionIndex = Number(button.dataset.optionPosition) - 1
              //console.log(opt, idx, optionIndex, value);
              if (idx === optionIndex) return opt === value;
              if (!selections[idx]) return true;
              return opt === selections[idx];
            });
          });
          const label = document.querySelector(`label[for="${button.id}"]`);
          label.classList.toggle('is-disabled', !isAvailable);
        });
    });
  }
  updateBidirectionalAvailability();
  document.addEventListener('variant:change', updateBidirectionalAvailability);
})();
